module.exports = __webpack_public_path__ + "static/illustration-e1d13505283e080ef19f77dc7566e00a.png";